export type QualityTier = 'excellent' | 'good' | 'watch' | 'poor' | 'unusable';

export const TIER_LABELS: Record<string, string> = {
  excellent: 'Excellent',
  good: 'Good',
  watch: 'Watch',
  poor: 'Poor',
  unusable: 'Unusable',
  unscored: 'Unscored',
};

export const TIER_BADGE_CLASSES: Record<string, string> = {
  excellent: 'bg-wt-green-primary/20 text-wt-green-primary',
  good: 'bg-blue-500/20 text-blue-400',
  watch: 'bg-wt-amber-primary/20 text-wt-amber-primary',
  poor: 'bg-orange-500/20 text-orange-400',
  unusable: 'bg-wt-red-primary/20 text-wt-red-primary',
  unscored: 'bg-gray-500/20 text-gray-400',
};

export const PV_HEALTH_LABELS: Record<string, string> = {
  fresh: 'Fresh',
  aging: 'Aging',
  stale: 'Stale',
  none: 'None',
};

export const PV_HEALTH_CLASSES: Record<string, string> = {
  fresh: 'text-wt-green-primary',
  aging: 'text-wt-amber-primary',
  stale: 'text-orange-400',
  none: 'text-wt-text-muted',
};

export const REASON_CODE_LABELS: Record<string, string> = {
  telemetry_coverage_low: 'Limited telemetry coverage (below 70%)',
  telemetry_coverage_critical: 'Very low telemetry coverage (below 40%)',
  telemetry_gap_recent: 'No telemetry received in the last 24 hours',
  pv_learning_none: 'PV learning unavailable; forecasts use fallback sources',
  pv_learning_stale: 'PV learning is stale; forecast confidence may be reduced',
  pv_learning_aging: 'PV learning is aging; will become stale soon',
  fallback_rate_high: 'High fallback rate; expected PV relies heavily on clear-sky estimates',
  clear_sky_dominant: 'Clear-sky estimates used moderately for expected PV',
  new_property: 'New property; quality will improve as data accumulates',
};

export function formatPercent(value: number | null | undefined): string {
  if (value == null) return '—';
  return `${(value * 100).toFixed(0)}%`;
}

export function formatScore(value: number | null | undefined): string {
  if (value == null) return '—';
  return value.toFixed(2);
}

export function reasonCodesToLabels(codes: string[] | null | undefined): string[] {
  if (!codes || codes.length === 0) return [];
  return codes.map(c => REASON_CODE_LABELS[c] ?? c);
}
